<template>
    <div>
        <div class="home-page__announcements-cards">
            <div class="container">
                <div class="row">
                    <div class="col-md-6" v-bind:key="index" v-for="(item, index) in MainDataItem">
                        <div class="generic-card">
                            <a :href="item.Url" class="generic-card-link">
                                <div class="card-img">
                                    <img :src="item.Image" alt="item.AnnouncementsTitle" @error="replaceByDefaultImg" />
                                </div>
                                <div class="card-content">
                                    <div class="inner-content">
                                        <h2 class="card-title">{{item.AnnouncementsTitle}}</h2>
                                        <span class="card-date">{{item.PublishedDate}}</span>
                                        <p class="card-details">{{item.Brief}}</p>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="col-md-6 all-small-cards">
                        <div class="row">
                            <div class="col-md-6 small-card" v-bind:key="index" v-for="(item, index) in FirstRowDataItems">
                                <div class="generic-card announcements-small-card">
                                    <a :href="item.Url" class="generic-card-link">
                                        <div class="card-img">
                                            <img :src="item.Image" :alt="item.AnnouncementsTitle" @error="replaceByDefaultImg" />
                                        </div>
                                        
                                        <div class="card-content">
                                            <div class="inner-content">
                                                <span class="card-date">{{item.PublishedDate}}</span>
                                                <h2 class="card-title">{{item.AnnouncementsTitle}}</h2>
                                                <p class="card-details">{{item.Brief}}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                       <!--  <div class="row">
                            <div class="col-md-6" v-bind:key="index" v-for="(item, index) in SecondRowDataItems">
                                <div class="generic-card announcements-small-card">
                                    <a :href="item.Url" class="generic-card-link">
                                        <div class="card-img">
                                            <img :src="item.Image" :alt="item.AnnouncementsTitle" @error="replaceByDefaultImg" />
                                        </div> 
                                        <div class="card-content">
                                            <div class="inner-content">
                                                <span class="card-date">{{item.PublishedDate}}</span>
                                                <p class="card-details">{{item.AnnouncementsTitle}}</p>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="home-page__announcements-cards home-page__announcements-mobile" v-if="isMobile">
            <swiper ref="awesomeSwiperAnnouncement" :options="swiperOptionGeneric">
                <swiper-slide v-bind:key="index" v-for="(item, index) in AnnouncementsData">
                    <div class="generic-card">
                        <a :href="item.Url" class="generic-card-link">
                            <div class="card-img">
                                <img :src="replaceByDefaultImg" :alt="item.AnnouncementsTitle" @error="replaceByDefaultImg" />
                            </div>
                            <div class="card-content">
                                <div class="inner-content">
                                    <span class="card-date">{{item.PublishedDate}}</span>
                                    <h2 class="card-title">{{item.AnnouncementsTitle}}</h2>
                                    <p class="card-details">{{item.Brief}}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </swiper-slide>
            </swiper>
        </div> -->
    </div>
</template>

<script>

    import axios from 'axios';
    let baseUrl = document.location.origin;
    let apiUrl = baseUrl + "";
    let contactApiUrl;
    let listingThis;

    //import { Swiper, SwiperSlide } from "vue-awesome-swiper";
    //import "swiper/dist/css/swiper.min.css";

    export default {
        components: {
            //Swiper,
            //SwiperSlide
        },
        props: {
            Pagesize: {
                type: String
            },
            Lang: {
                type: String
            }
        },
        data() {
            return {
                AnnouncementsData: [],
                MainDataItem: [],
                FirstRowDataItems: [],
                SecondRowDataItems: [],
                isMobile: false,
                swiperOptionGeneric: {
                    pagination: {
                        el: ".swiper-pagination",
                        dynamicBullets: true,
                        clickable: true,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        500: {
                            loop: false,
                            slidesPerView: 1.07,
                            spaceBetween: 10,
                            allowTouchMove: true,
                            centeredSlides: false
                        },
                    },
                }
            }
        },
        methods: {
            getData: function () {
                listingThis.isAjaxLoading = true;
                contactApiUrl = `${apiUrl}/umbraco/surface/Announcements/GetLatestAnnouncements?culture=${listingThis.Lang}&pageSize=${listingThis.Pagesize}`
                axios.get(contactApiUrl, {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                }).then(function (response) {
                    listingThis.AnnouncementsData = response.data;
                    listingThis.MainDataItem = response.data.slice(0, 1);
                    listingThis.FirstRowDataItems = response.data.slice(1, 5);
                })
                //TODO Probably will need to make our dates disabled till load
            },
            replaceByDefaultImg(e) {
                e.target.src = "../../../../../src/assets/favicon.png";
            }
        },
        mounted() {
            listingThis = this;
            listingThis.getData();

            if (window.innerWidth < 768) {
                listingThis.isMobile = true;
            }
        },
        watch: {

        }
    };
</script>
